export default "__VITE_PUBLIC_ASSET__2dcfdc67__"